import { Tag } from 'antd';
import { routePaths } from 'router';
import { useGetTransportAvailabilityStatus } from 'api/transports/use-get-transport-availability-status';
import { TransportType } from 'types/transport';
import styles from './transport-availability-status.module.scss';
import { ETransportAvailabilityStatusRecord, type ITransportAvailabilityStatusProps } from './types';

export const TransportAvailabilityStatus: React.FC<ITransportAvailabilityStatusProps> = (props) => {
  const { status, transportId, transportType } = props;
  const enabled = (status === 'planning' || status === 'ready') && !!transportId;
  const { data, isLoading } = useGetTransportAvailabilityStatus(transportId, { enabled });

  if (isLoading || !enabled || data?.status === ETransportAvailabilityStatusRecord.free) return null;

  const tripLink = `${routePaths.trips}/${data?.trip?.id}`;

  return (
    <Tag color='red' className={styles.tag}>
      {transportType === TransportType.truck ? 'Truck is busy' : 'Trailer is busy'}
      {': '}
      <a href={tripLink} target='_blank' rel='noopener noreferrer'>
        {data?.trip?.compositeId}
      </a>
    </Tag>
  );
};
